export const ConfigType = {
  ConfigWiFiName: 1, //配置wifi时 WiFi名称
  ConfigWiFiPassword: 2, //配置wifi时 WiFi密码
  ConfigWiFiNameAndPassword: 3, //配置wifi时 WiFi名称和密码
  ConfigWiFiNameAndPasswordJson:4, //配置wifi时 WiFi名称和密码 json格式
}

// 判断是否有wifi配置
export function isWifiConfig(configItem = {}) {
  const GpDetails = configItem.GpDetails || [];

  const isWifi = GpDetails.find(item => 
    item.ValueType === 'Input' && 
    [
      ConfigType.ConfigWiFiName,
      ConfigType.ConfigWiFiPassword,
      ConfigType.ConfigWiFiNameAndPassword, 
      ConfigType.ConfigWiFiNameAndPasswordJson
    ].includes(item.UI?.ConfigType)
  );

  return isWifi;
}

// 判断是否是json格式的高级wifi
export function isWifiConfigJson(configItem = {}) {
  const GpDetails = configItem.GpDetails || [];

  const isWifiJson = GpDetails.find(item => 
    item.ValueType === 'Input' && 
    item.UI?.ConfigType === ConfigType.ConfigWiFiNameAndPasswordJson);

  return !!isWifiJson;
}

// 判断是否是json格式的高级wifi
export function isWifiConfig16(configItem = {}) {
  const GpDetails = configItem.GpDetails || [];

  const isWifiJson = GpDetails.find(item => 
    item.ValueType === 'Input' && 
    item.UI?.ConfigType === ConfigType.ConfigWiFiNameAndPassword);

  return isWifiJson;
}

